import * as go from 'gojs';
import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { NodeCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useClickModelConceptClassLink = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    (item: SelectItem) => {
      if (!item) {
        return;
      }

      // Canvas highlight is the only diagram-dependent step; skip it headless.
      if (diagram && !diagram.headless) {
        const nodes = diagram.findNodesByExample({
          value: item.value,
          category: NodeCategory.MODEL_CONCEPT_CLASS,
        });

        commitDiagramWhileSkippingUndoManager(
          diagram,
          (_, diagram) => setDiagramSelection(new go.Set(nodes), true)(diagram),
          DiagramTransaction.SET_DIAGRAM_SELECTION
        );
      }

      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: item.value,
            type: EntityDrawerType.CLASS,
          },
        })
      );
    },
    [diagram, dispatch, projectId]
  );
};
